module.exports = __webpack_public_path__ + "static/graph-1-c3890869fe8e5bca92aec71a67955c62.svg";